import * as React from 'react';
import * as Noty from 'noty';
import Sound from 'react-sound';
import { withTranslation } from "react-i18next";

import * as styles from './style.css';
import Icon from "../../../../icons/Icon";
import { getDurationString } from "../../../../uq-ui/helpers/duration";
import { createClassNames } from '../../../../../infrastructure/helpers';

class StickersComponentsMediaAudio extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      sliderWidth: 0,
      currentSeconds: 0,
      totalDuration: null,
      supportError: false,
      playStatus: Sound.status.PAUSED,
    };
  }

  isFirstPlayPressed = false;

  componentWillUnmount() {
    if (this._nativeAudioEl) {
      this._nativeAudioEl.removeEventListener('timeupdate', this.onNativeTimeUpdate);
      this._nativeAudioEl.removeEventListener('ended', this.onFinishedPlaying);
    }
  }

  onNativeTimeUpdate = (event) => {
    this.setState({
      currentSeconds: event.target.currentTime,
      totalDuration: event.target.duration
    });
  };

  onPlayPausePressed = () => {
    if (!this.isFirstPlayPressed) {
      try {
        this._nativeAudioEl.play().catch(() => {});
        this._nativeAudioEl.pause();
        this.isFirstPlayPressed = true;
      } catch (e) {
        console.log('e', e);
      }
    }
    if (this.state.playStatus !== Sound.status.PLAYING) {
      if (this.state.supportError) {
        this._nativeAudioEl.play();
      }
      this.setState({ playStatus: Sound.status.PLAYING });
    } else {
      if (this.state.supportError) {
        this._nativeAudioEl.pause();
      }
      this.setState({ playStatus: Sound.status.PAUSED });
    }
  };

  onPlaying = ({ position, duration }) => {
    const currentSeconds = position / 1000;
    this.setState({ currentSeconds, totalSeconds: duration / 1000 });
  };

  onFinishedPlaying = () => {
    this.setState({
      playStatus: Sound.status.STOPPED,
      currentSeconds: 0
    });
  };

  onPlayingError = (errorCode) => {
    this._nativeAudioEl.play();
    this.setState({ supportError: true });
  };

  onNativePlayingError = (error) => {
    if (this.state.supportError) {
      new Noty({
        type: 'error',
        text: this.props.t('supportError'),
      }).show();
    }
  };

  getTotalDurationSeconds() {
    if (this.props.duration) return this.props.duration;
    if (this.state.totalSeconds) {
      return this.state.totalSeconds;
    }
    return 0;
  }

  renderPlayPauseButton() {
    const isPlaying = this.state.playStatus === Sound.status.PLAYING;
    const pauseIconStyles = [styles.icon];
    const playIconStyles = [styles.icon, styles.playIcon];
    if (isPlaying) {
      pauseIconStyles.push(styles.activeIcon);
    } else {
      playIconStyles.push(styles.activeIcon);
    }

    const pauseIconClassNames = createClassNames(pauseIconStyles);
    const playIconClassNames = createClassNames(playIconStyles);

    return (
      <div onClick={this.onPlayPausePressed}
           className={styles.button}>
        <Icon name="Pause"
              width="25"
              height="25"
              className={pauseIconClassNames}/>
        <Icon name="Play"
              width="25"
              height="25"
              className={playIconClassNames}/>
      </div>
    );
  }

  onAudioRef = (ref) => {
    this._nativeAudioEl = ref;
    if (this._nativeAudioEl != null) {
      this._nativeAudioEl.addEventListener('timeupdate', this.onNativeTimeUpdate);
      this._nativeAudioEl.addEventListener('ended', this.onFinishedPlaying);
    }
  };
  
  render() {
    const currentDuration = getDurationString(this.state.currentSeconds);
    const totalDurationSeconds = this.getTotalDurationSeconds();
    const totalDuration = getDurationString(totalDurationSeconds);
    const sliderWidth = this.state.currentSeconds * 100 / totalDurationSeconds;
    const sliderWidthPercent = `${(sliderWidth >= 100 ? 100 : sliderWidth)}%`;

    return (
      <div className={styles.container}>
        <div className={styles.btnContainer}>
          <Icon name="AudioBg" width="100%" className={styles.equalizeBg} />
          {this.renderPlayPauseButton()}
        </div>
        <audio ref={this.onAudioRef}
               onError={this.onNativePlayingError}
               controls className={styles.dNone}>
          <source src={this.props.source} type="audio/mp4"/>
          Your browser does not support the video tag.
        </audio>

        { !this.state.supportError && (
          <Sound url={this.props.source}
                 playStatus={this.state.playStatus}
                 autoPlay={false}
                 onStop={this.onStop}
                 onPlaying={this.onPlaying}
                 onFinishedPlaying={this.onFinishedPlaying}
                 onError={this.onPlayingError}/>
        ) }

        <div className={styles.progress}>
          <div className={styles.progressFill} style={{ width: sliderWidthPercent }}>
            <div className={styles.progressBar}/>
          </div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.currentDuration}>
            <Icon name="Microphone" width="15" height="20" className={styles.microphone} />
            <span className={styles.duration}>{ currentDuration || '0:00' }</span>
          </div>
          <div className={styles.totalDuration}>
            <span className={styles.duration}>{ totalDuration }</span>
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation('cmp-media-audio')(StickersComponentsMediaAudio);


// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/media-audio/index.jsx